import React, { memo } from "react";
import { Link } from "react-router-dom";

const UserRow = ({ user, onUpdate }) => {
  return (
    <tr className="tw-hover:bg-slate-100 tw-transition-colors">
      <td className="tw-flex tw-gap-3 tw-items-center tw-p-2 tw-px-4">
        <img
          src={user.avatar || "/default-avatar.png"}
          alt="profile"
          className="tw-rounded-md tw-w-8 tw-h-8 tw-object-cover"
          onError={(e) => {
            e.target.src = "/default-avatar.png";
          }}
        />
        {user.name}
      </td>
      <td className="tw-p-2 tw-px-4">{user.username}</td>
      <td className="tw-p-2 tw-px-4">{user.phone || "-"}</td>
      <td className="tw-p-2 tw-px-4">{user.balance?.toLocaleString() || "0"}</td>
      <td className="tw-p-2 tw-px-4">{user.cut || 0}%</td>
      <td className="tw-p-2 tw-px-4 tw-capitalize">{user.role || "-"}</td>
      <td className="tw-p-2 tw-px-4">
        {Array.isArray(user.branch) ? user.branch.join(", ") : user.branch || "-"}
      </td>
      <td className="tw-p-2 tw-px-4">
        <span
          className={`tw-px-2 tw-py-1 tw-rounded-full tw-text-xs ${
            user.status === false
              ? "tw-bg-red-100 tw-text-red-800"
              : "tw-bg-green-100 tw-text-green-800"
          }`}
        >
          {user.status === false ? "Inactive" : "Active"}
        </span>
      </td>
      <td className="tw-p-2 tw-px-4">{user.minBetAmount || "-"}</td>
      <td className="tw-p-2 tw-px-4 tw-text-center">
        <Link
          to={`/update-user/${user._id}`}
          className="tw-text-purple-600 hover:tw-text-purple-800 tw-transition-colors"
        >
          Edit
        </Link>
      </td>
    </tr>
  );
};

export default memo(UserRow);